export default "__VITE_ASSET__d22698b2__"